<template>
  <div id="contenedor-default-contrato">
    <h1>Contratista</h1>
  </div>
</template>

<script>
export default {
  name: 'DefaultContrato',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
